import { workerUseYnType } from '@/constants/worker/workerUseYn';
import { convertCase } from '@/utils';
import { i18n } from '@/locales';
const { t } = i18n;
const lc = 'views.worker.worker_profit.';
export const workerProfitUseYnType = {
    ...workerUseYnType,
    // 전체
    ALL: 'ALL',
};
const workerProfitUseYnTypeList = [
    workerProfitUseYnType.ALL,
    workerProfitUseYnType.OK,
    workerProfitUseYnType.STOP,
    workerProfitUseYnType.LEAVE,
];
const workerProfitUseYnTypeOptionList = workerProfitUseYnTypeList
    .map((value) => {
    const text = convertCase(value, 'enum', 'snake');
    let imgIcon = '';
    // "전체" 에 대한 아이콘 무
    if (value !== workerProfitUseYnType.ALL) {
        imgIcon = text;
    }
    return {
        text: t(lc + text),
        value,
        imgIcon,
    };
});
export { workerProfitUseYnTypeOptionList };
